module.exports = __webpack_public_path__ + "img/54.8f25bbf8.png";